import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser } from '../services/users';
import { userKeys } from './useUsersQuery';
import type { CreateUserFormInputs } from '../schemas/user.schema';
import type { AdminUser } from '../types/users.types';

export const useCreateUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, CreateUserFormInputs>({
        mutationFn: (payload) => createUser(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
    });
};
